import axios from "axios";

const baseURL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = window.localStorage.getItem("atelier-token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Sessione scorrevole: al primo 401 tenta il rinnovo con il refresh token e
// ripete la richiesta. La sessione resta aperta finché non si fa logout.
let refreshPromise = null;

const refreshSession = () => {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${baseURL}/auth/refresh`, { refresh_token: window.localStorage.getItem("atelier-refresh") }, { withCredentials: true })
      .then(({ data }) => {
        window.localStorage.setItem("atelier-token", data.access_token);
        if (data.refresh_token) window.localStorage.setItem("atelier-refresh", data.refresh_token);
        return data.access_token;
      })
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const isAuthCall = original?.url?.includes("/auth/login") || original?.url?.includes("/auth/refresh") || original?.url?.includes("/auth/logout");
    if (error.response?.status === 401 && original && !original._retried && !isAuthCall && window.localStorage.getItem("atelier-refresh")) {
      original._retried = true;
      try {
        const token = await refreshSession();
        original.headers.Authorization = `Bearer ${token}`;
        return api(original);
      } catch {
        window.localStorage.removeItem("atelier-token");
        window.localStorage.removeItem("atelier-refresh");
        if (window.location.pathname !== "/login") window.location.assign("/login");
      }
    }
    return Promise.reject(error);
  }
);

const FIELD_LABELS = {
  completion_note: "Nota di chiusura",
  reference_contact_name: "nome referente",
  reference_contact_role: "ruolo referente",
  client_id: "cliente",
  title: "titolo",
  event_date: "data evento",
  start_time: "ora inizio",
  end_time: "ora fine",
  service_type: "servizio",
  assignee_ids: "assegnatari",
  compensation: "compenso",
  estimated_hours: "ore stimate",
  email: "email",
  phone: "telefono",
};

export const getErrorMessage = (error) => {
  const detail = error?.response?.data?.detail;
  if (Array.isArray(detail)) {
    // Gli errori di business dei validator hanno un messaggio chiaro: mostralo così com'è
    const customMessages = [...new Set(detail
      .filter((item) => String(item?.type || "").startsWith("value_error"))
      .map((item) => String(item?.msg || "").replace(/^Value error, /, ""))
      .filter(Boolean))];
    if (customMessages.length) return customMessages.join(" · ");
    const fields = [...new Set(detail.map((item) => item?.loc?.[item.loc.length - 1]).filter((field) => field && field !== "body"))];
    const labels = fields.map((field) => FIELD_LABELS[field] || String(field).replaceAll("_", " "));
    return labels.length ? `Dati non validi nei campi: ${labels.join(", ")}.` : "Dati non validi: controlla i campi obbligatori.";
  }
  return detail || "Non è stato possibile completare l'operazione.";
};